module.exports = __webpack_public_path__ + "static/media/home_view_places.a7e8e60b.jpg";